import { render, staticRenderFns } from "./CreateLevelHeader.vue?vue&type=template&id=3189017c"
import script from "./CreateLevelHeader.vue?vue&type=script&lang=js"
export * from "./CreateLevelHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports